// extracted by mini-css-extract-plugin
module.exports = {"activity_page":"CarnivalGuide_activity_page__22IfZ","imageContent":"CarnivalGuide_imageContent__2sExA","btn_box":"CarnivalGuide_btn_box__1evRe","mask":"CarnivalGuide_mask__1gQkb"};